// 沪市
const SH_INDEX = 0x00000001 // 沪市-指数
const SH_A = 0x00000002 // 沪市-A股
const SH_B = 0x00000004 // 沪市-B股
const SH_JJ = 0x00000008 // 沪市-基金
const SH_ZQ = 0x00000010 // 沪市-债券
const SH_ZZ = 0x00000020 // 沪市-转债
const SH_ST = 0x00000040 // 沪市-ST股
const SH_HG = 0x00800000 // 沪市-回购
const SH_WIT = 0x00000100 // 沪市-国债预发行
const SH_N = 0x00000200 // 沪市-新股
const SH_OTHER = 0x00000400 // 沪市-其他
const SH_Z = 0x00000800 // 沪市-沪退市整理
const SH_OPTIONS = 0x00001000 // 沪市-期权
const SH_CEF = 0x00002000 // 沪市-封闭式基金
const SH_OEF = 0x00004000 // 沪市-开放式基金
const SH_ETF = 0x00008000 // 沪市-ETF式基金
const SH_LOF = 0x00010000 // 沪市-LOF式基金
const SH_XGZ = 0x00020000 // 沪市-沪小公债
const SH_HGT = 0x00040000 // 沪市-沪港通中的沪股通
const SH_AH = 0x00080000 // 沪市-沪市AH股
const SH_GPQQBD = 0x00100000 // 沪市-沪市股票期权标的股
const SH_JJ_A = 0x00200000 // 沪市-沪市分级A基金
const SH_JJ_B = 0x00400000 // 沪市-沪市分级B基金
const SH_YXZZ = 0x01000000 // 沪市-沪市有效转债
const SH_FXJS = 0x02000000 // 沪市-沪市风险警示
const SH_KCB = 0x04000000 // 沪市-沪科创板
const SH_HLT = 0x10000000 // 沪市-沪伦通沪伦通GDR

// 深市
const SZ_INDEX = 0x00000001 // 深市-指数
const SZ_A = 0x00000002 // 深市-A股
const SZ_B = 0x00000004 // 深市-B股
const SZ_JJ = 0x00000008 // 深市-基金
const SZ_ZQ = 0x00000010 // 深市-债券
const SZ_ZZ = 0x00000020 // 深市-转债
const SZ_ST = 0x00000040 // 深市-ST股
const SZ_HG = 0x80000000 // 深市-回购
const SZ_N = 0x00000100 // 深市-新股
const SZ_OTHER = 0x00000200 // 深市-其他
const SZ_ZXB = 0x00000400 // 深市-深中小板888888
const SZ_CYB = 0x00000800 // 深市-深创业板
const SZ_SXB = 0x00001000 // 深市-深三板
const SZ_Z = 0x00002000 // 深市-退市整理
const SZ_CEF = 0x00004000 // 深市-封闭式基金
const SZ_OEF = 0x00008000 // 深市-开放式基金
const SZ_ETF = 0x00010000 // 深市-ETF式基金
const SZ_LOF = 0x00020000 // 深市-LOF式基金
const SZ_XSBXYZL = 0x00040000 // 深市-新三板协议转让
const SZ_XSBZSZL = 0x00080000 // 深市-新三板做市转让
const SZ_XSBCXC = 0x00100000 // 深市-新三板创新层
const SZ_XSBJCC = 0x00200000 // 深市-新三板基础层
const SZ_XSBJJJL = 0x400000000 // 深市-新三板竞价转让
const SZ_A_TS = 0x00400000 // 深市-两网及A股退市
const SZ_B_TS = 0x00800000 // 深市-B股退市
const SZ_NZL = 0x01000000 // 深市-新增及首日转让
const SZ_TS = 0x02000000 // 深市-股转系统-两网及退市（三板）
const SZ_GPGS = 0x04000000 // 深市-股转系统-挂牌公司
const SZ_SGT = 0x08000000 // 深市-深港通中的深股通
const SZ_AH = 0x10000000 // 深市-AH
const SZ_JJ_A = 0x20000000 // 深市-分级A基金
const SZ_JJ_B = 0x40000000 // 深市-分级B基金
const SZ_ZQZYSHG = 0x80000000 // 深市-深市债券质押式回购
const SZ_XSB_INDEX = 0x100000000 // 深市新三板指数
const SZ_YXZZ = 0x200000000 // 深市-深市有效转债

// 板块
const BK_GN = 0x00000001 // 概念板块
const BK_HY = 0x00000002 // 行业板块
const BK_DQ = 0x00000004 // 地区板块
const BK_ZGN = 0x00000008 // 子概念板块
const BK_ZHY = 0x00000010 // 子行业板块

// 股指国债期货
const GZGZQH_INDEX_QH = 0x00000001 // 股指期货
const GZGZQH_ND_QH = 0x00000002 // 国债期货
const GZGZQH_HS300 = 0x00000008 // 以沪深300为标的的期货，即IF
const GZGZQH_SZ50 = 0x00000010 // 以上证50为标的的期货，即IH
const GZGZQH_ZZ500 = 0x00000020 // 以中证500为标的的期货，即IC

// 港股
const HK_ZB = 0x00000001 // 港股-香港主板
const HK_SH = 0x00000002 // 港股-沪市H股
const HK_AH = 0x00000004 // 港股-AH股对应的H股
const HK_HGT = 0x00000008 // 港股-沪港通中的港股通
const HK_SGT = 0x00000010 // 港股-深港通中的港股通
const HK_INDEX = 0x00000020 // 港股-指数

// 环球指数
const GLOBAL_MZ_INDEX = 0x00000001 // 环球指数-美洲市场指数
const GLOBAL_OZ_INDEX = 0x00000002 // 环球指数-欧洲市场指数
const GLOBAL_YT_INDEX = 0x00000004 // 环球指数-亚太市场指数

// 国际商品期货
const GJSPQH_NY = 0x00000001 // 国际商品期货-能源
const GJSPQH_GJS = 0x00000002 // 国际商品期货-贵金属
const GJSPQH_JBJS = 0x00000004 // 国际商品期货-基本金属
const GJSPQH_NCP = 0x00000008 // 国际商品期货-农产品

// 美股中国概念股
const USA_CN_NYSE = 0x00000001 //  美股中国概念股-纽交所上市
const USA_CN_NASDAQ = 0x00000002 // 美股中国概念股-纳斯达克上市
const USA_CN_MJS = 0x00000004 // 美股中国概念股-美交所上市
const USA_CN_PINK = 0x00000008 // 美股中国概念股-PINK市场
const USA_CN_OTC = 0x00000010 // 美股中国概念股-OTC市场
const USA_CN_DJIA = 0x00000020 // 美股中国概念股-道琼斯指数成分股
const USA_CN_ZGG = 0x00000040 // 美股中国概念股-中概股（中概股二级列表使用该Category）

// 国际汇率
const GJHL = 0x00000001 // 国际汇率

// 人民币牌价
const RMB_PJ = 0x00000001 // 人民币牌价

export default {
  SH_INDEX,
  SH_A,
  SH_B,
  SH_JJ,
  SH_ZQ,
  SH_ZZ,
  SH_ST,
  SH_HG,
  SH_WIT,
  SH_N,
  SH_OTHER,
  SH_Z,
  SH_OPTIONS,
  SH_CEF,
  SH_OEF,
  SH_ETF,
  SH_LOF,
  SH_XGZ,
  SH_HGT,
  SH_AH,
  SH_GPQQBD,
  SH_JJ_A,
  SH_JJ_B,
  SH_YXZZ,
  SH_FXJS,
  SH_KCB,
  SH_HLT,

  SZ_INDEX,
  SZ_A,
  SZ_B,
  SZ_JJ,
  SZ_ZQ,
  SZ_ZZ,
  SZ_ST,
  SZ_HG,
  SZ_N,
  SZ_OTHER,
  SZ_ZXB,
  SZ_CYB,
  SZ_SXB,
  SZ_Z,
  SZ_CEF,
  SZ_OEF,
  SZ_ETF,
  SZ_LOF,
  SZ_XSBXYZL,
  SZ_XSBZSZL,
  SZ_XSBCXC,
  SZ_XSBJCC,
  SZ_XSBJJJL,
  SZ_A_TS,
  SZ_B_TS,
  SZ_NZL,
  SZ_TS,
  SZ_GPGS,
  SZ_SGT,
  SZ_AH,
  SZ_JJ_A,
  SZ_JJ_B,
  SZ_ZQZYSHG,
  SZ_XSB_INDEX,
  SZ_YXZZ,

  BK_GN,
  BK_HY,
  BK_DQ,
  BK_ZGN,
  BK_ZHY,

  GZGZQH_INDEX_QH,
  GZGZQH_ND_QH,
  GZGZQH_HS300,
  GZGZQH_SZ50,
  GZGZQH_ZZ500,

  HK_ZB,
  HK_SH,
  HK_AH,
  HK_HGT,
  HK_SGT,
  HK_INDEX,

  GLOBAL_MZ_INDEX,
  GLOBAL_OZ_INDEX,
  GLOBAL_YT_INDEX,

  GJSPQH_NY,
  GJSPQH_GJS,
  GJSPQH_JBJS,
  GJSPQH_NCP,

  USA_CN_NYSE,
  USA_CN_NASDAQ,
  USA_CN_MJS,
  USA_CN_PINK,
  USA_CN_OTC,
  USA_CN_DJIA,
  USA_CN_ZGG,

  GJHL,

  RMB_PJ
}
